import React, { PureComponent } from "react";
import { Col, Button, Tooltip } from "antd";
import _ from "lodash";
import nanoid from "nanoid";
import QuestionTags from "./questionTags";
import config from "../../config";

const COL_LAYOUT = {
  style: { marginBottom: "30px", paddingLeft: 8, paddingRight: 8 },
  xs: 12,
  sm: 12,
  md: 8
  // lg={6}
};

class Result extends PureComponent {
  editQuestionTags(qData, tags, status) {
    this.props.handleQuestionTags(qData, tags, status);
    // debugger;
  }
  editQuestionAnswerTags = (qData, tags, answerIndex, status) => {
    this.props.handleQuestionAnswerTag(qData, tags, answerIndex, status);
  };
  constructor(props) {
    super(props);
  }
  checkIfEmpty(data) {
    var data = _.cloneDeep(JSON.parse(data));
    return data.length === 1 && data[0].answer.length === 0;
  }

  render() {
    const { children, data, onAdd, onRemove } = this.props;
    if (data) console.log("props data: " + JSON.stringify(data));
    else console.log("props: " + JSON.stringify(this.props));

    return (
      <div
        style={{
          textAlign: "left",
          position: "relative",
          border: "1px solid #eee",
          padding: "16px 42px 16px 16px"
        }}
      >
        <b style={{ position: "absolute", right: "12px", top: 50 }}>
          {data.questionType}
        </b>
        <Button
          style={{ position: "absolute", right: 10, top: 10 }}
          type="primary"
          shape="circle"
          icon="plus"
          onClick={() => onAdd(data)}
        />
        <Button
          style={{ position: "absolute", left: -10, top: -15 }}
          type="danger"
          shape="circle"
          icon="minus"
          onClick={() => onRemove(data)}
        />
        <span style={{ xbackground: "red" }}>{children}</span>

        <div style={{ marginTop: "20px" }}>
          <QuestionTags
            tags={data.tags}
            questionData={data}
            onTarget="question"
            onEditQuestionTags={this.editQuestionTags.bind(this)}
          />
        </div>

        <div>{this.props.data.answers === ""}</div>

        {this.checkIfEmpty(this.props.data.answers) ? (
          <span />
        ) : (
          <div style={{ marginTop: "20px" }}>
            <strong>Answers:</strong>
            <ul>
              {JSON.parse(data.answers).map(obj => {
                return (
                  <li key={nanoid()}>
                    <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                      {obj.answer ? obj.answer : ""}
                    </div>
                    <div>
                      <QuestionTags
                        tags={obj.tags}
                        questionData={data}
                        onAnswer={obj.answer}
                        onTarget="answer"
                        onEditQuestionTags={this.editQuestionAnswerTags.bind(
                          this
                        )}
                      />
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

class Results extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reloadLoading: false,
      allData: [],
      currentShowData: 20,
      amountDataPerLoad: 20,
      finishLoaded: false,
      totalNumberData: -1,
      lastFilteredHasMeta: null
      // filteredResults: []
    };
  }

  onEditQuestionTags = (qData, tags, status) => {
    this.props.handleQuestionTags(qData, tags, status);
    var existingTag = this.props.data[0][qData.firebaseKey].tags;
    // debugger;
    var currentTags = existingTag ? existingTag : {};
    var newTag = {};
    var newEditTag = Object.values(tags)[0];
    newTag[newEditTag] = newEditTag;
    var insertTag = Object.assign(currentTags, newTag);
    this.props.data[0][qData.firebaseKey].tags = _.cloneDeep(insertTag);
  };

  onEditQuestionAnswerTags = (qData, tags, answerIndex, status) => {
    this.props.handleQuestionAnswerTags(qData, tags, answerIndex, status);
    var answers = JSON.parse(this.props.data[0][qData.firebaseKey].answers);
    var currentTags = answers[answerIndex].tags
      ? answers[answerIndex].tags
      : {};
    var newTag = {};
    newTag[tags.val] = tags.val;
    var insertTag = Object.assign(currentTags, newTag);
    if (answers.length > 0) {
      answers[answerIndex]["tags"] = insertTag;
      this.props.data[0][qData.firebaseKey].answers = _.cloneDeep(
        JSON.stringify(answers)
      );
    }
  };

  findArrayObjects = arr => {
    if (Array.isArray(arr))
      if (Object.prototype.toString.call(arr[0]) === "[object Object]")
        return arr;
      else if (Array.isArray(arr[0])) return this.findArrayObjects(arr[0]);
      else return [];
    else return [];
  };

  // componentWillUpdate = (a,b) => {
  //   console.log('update!!!!')
  //   this.forceUpdate()
  // }

  filterResults = (results, currentShown) => {
    const { searchKey = [], filteredHasMeta = '' } = this.props;
    const key = searchKey;

    function checkWithSearchKey(obj) {
      if (key.length > 0) {
        let result = key.reduce(function(a, k, i) {
          if (obj.toLowerCase().indexOf(k.toLowerCase()) >= 0) a.push(i);
          return a;
        }, []);
        return key.length === result.length ? true : false;
      } else return true;
    }

    function multipleKeySearch() {}

    function removeEmptyValue(arr) {
      return _.compact(arr);
    }

    function flattenArr(arr) {
      return [].concat.apply([], arr);
    }

    var finalResult = this.findArrayObjects(results);

    if (finalResult.length > 0) {
      var res = _(finalResult[0])
        .filter(o => {
          // console.log('final result o: ', o)
          var answers = _.cloneDeep(_.values(JSON.parse(o.answers)));
          answers.map(answer => {
            if (answer["tags"]) answer["tags"] = _.values(answer["tags"]);
          });

          var qTextSK = o.questionText;
          var qTagSK = removeEmptyValue(_.values(o.tags)).join(" ");
          var qAnswerSK = removeEmptyValue(_.map(answers, "answer")).join(" ");
          var qAnswerTagSK = flattenArr(
            removeEmptyValue(_.map(answers, "tags"))
          ).join(" ");

          var searchKeyFilters = checkWithSearchKey(
            qTextSK + " " + qTagSK + " " + qAnswerSK + " " + qAnswerTagSK
          ); // Search All

          if (filteredHasMeta !== '') {
            return o.hasMeta === filteredHasMeta && searchKeyFilters;
          }
          return searchKeyFilters;
        })
        .value();

      // console.log('filtered Found!', res)

      if (key.length !== 0) {
        // If searchKey found
        this.setState({
          totalNumberData: res.length
        });
      }

      // console.log('this.state.lastFilteredHasMeta -> ' + this.state.lastFilteredHasMeta)
      // console.log('filteredHasMeta: ' + filteredHasMeta)

      if (this.state.lastFilteredHasMeta !== filteredHasMeta) {
        this.setState({
          lastFilteredHasMeta: filteredHasMeta,
          currentShowData: 20,
          totalNumberData: res.length,
          finishLoaded: 20 >= res.length ? true : false
        });
      }

      // if(filteredHasMeta === true){
      //   this.setState({ totalNumberData: res.length })
      // }

      // else this.setState({ totalNumberData: res.length });
      // alert('filteredHasMeta: ' + filteredHasMeta)
      return _.compact(this.first(res, currentShown));
    } else return [];
  };

  handleHoverEnter = () => {
    // alert('mouse enter.')
  };

  handleHoverLeave = () => {
    // alert('mouse leave.')
  };

  first = (arr, num) => {
    var filteredArr = [];
    if (arr.length > 0) {
      for (var i = 0; i < num; i++) {
        filteredArr.push(arr[i]);
      }
      return filteredArr;
    } else return filteredArr;
  };

  reloadMore = () => {
    // if(data.length > 0) {
    const { currentShowData, totalNumberData } = this.state;
    var nextShowData = currentShowData + this.state.amountDataPerLoad;
    this.setState({
      currentShowData: nextShowData,
      reloadLoading: true,
      finishLoaded: nextShowData >= totalNumberData ? true : false
    });
    // }
  };

  getTotalNumberData = res => {
    return _.values(res[0]).length;
  };

  // componentDidMount() {
  //   const {
  //     data = [],
  //     totalQuestionsFromFiles
  //   } = this.props;

  //   if (this.state.totalNumberData === -1 && data.length > 0)
  //     this.setState({ totalNumberData: this.getTotalNumberData(data) });

  //   console.log('haha -> ' + JSON.stringify(this.filterResults(data, this.state.currentShowData)));
  //   this.setState( { filteredResults : this.filterResults(data, this.state.currentShowData) });
  //   if (totalQuestionsFromFiles !== -1) {
  //     this.setState({ totalNumberData: totalQuestionsFromFiles });
  //   }
  //   // console.log()
  //   console.log('hello haha: ' + JSON.stringify(this.state));
  //   console.log('hello props: ' + JSON.stringify(this.props));

  // }

  render() {
    const {
      searchKey,
      data = [],
      onAdd,
      onRemove,
      totalQuestionsFromFiles
    } = this.props;

    if (this.state.totalNumberData === -1 && data.length > 0)
      this.setState({ totalNumberData: this.getTotalNumberData(data) });

    var filteredResults = this.filterResults(data, this.state.currentShowData);
    if (totalQuestionsFromFiles !== -1) {
      this.setState({ totalNumberData: totalQuestionsFromFiles });
    }

    console.log('filteredResults render ' + JSON.stringify(filteredResults));


    return (
      <div style={{ display: "table", width: "100%" }}>
        {/*<div>totalNumberData: { this.state.totalNumberData }</div>
          <div>totalQuestionsFromFiles: { totalQuestionsFromFiles }</div>*/}
        {/*<div>filteredResults: <pre>{ filteredResults.map((o,ind) => { return o; }) }</pre></div>*/}

        <div style={{ fontSize: "1rem", marginBottom: 16 }}>
          {`Questions we've found...${searchKey ? `for ${searchKey}` : ""}`}
        </div>
        <div style={{ display: "table-row" }}>
          {filteredResults.map((o, ind) => {
            if (ind === this.state.currentShowData - 1) {
              this.state.reloadLoading = false;
              this.state.doneFiltered = true;
            }

            return (
              <Col {...COL_LAYOUT} key={nanoid()}>
                <Result
                  data={o}
                  onAdd={onAdd}
                  onRemove={onRemove}
                  handleQuestionTags={this.onEditQuestionTags.bind(this)}
                  handleQuestionAnswerTag={this.onEditQuestionAnswerTags.bind(
                    this
                  )}
                >
                  <div>
                    <span style={{ fontStyle: "italic" }}>
                      Survey {o.surveyName}
                    </span>
                  </div>
                  <div>{o.questionText}</div>
                </Result>
              </Col>
            );
          })}
        </div>

        {this.state.totalNumberData === -1 ? (
          <h3>Loading questions...</h3>
        ) : this.state.totalNumberData === 0 ? (
          <h3>Don't have any questions yet. Please upload.</h3>
        ) : (
          <div />
        )}

        {this.state.doneFiltered && (
          <div>
            {this.state.finishLoaded === false ? (
              <Button
                type="primary"
                loading={this.state.reloadLoading}
                onClick={this.reloadMore}
              >
                Load More
              </Button>
            ) : (
              <h3>End of result</h3>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Results;



// WEBPACK FOOTER //
// ./src/components/dashboard/Results.js